import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface SliderDriver extends BaseDriver {
  isDotSelected: (value: number) => boolean;
  numOfSliderDots: () => number;
  numOfSliderHandles: () => number;
  numOfSliderMarksLabels: () => number;
  getToolTipValue: (index: number) => string;
  isDisabled: () => boolean;
  getDirection: () => 'vertical' | 'horizontal';
}
